import { H1, P, Section } from '@ahmdigital/ui';
import React from 'react';

import { CompareCoverGroup } from '../../../types';
import CompareCoverTable from './compare-table';

const CompareCover = ({ contentTitle, covers, description, features }: CompareCoverGroup) => (
  <Section>
    <H1 looksLike="h3">{contentTitle}</H1>
    {description && <P>{description}</P>}
    <CompareCoverTable covers={covers} features={features} />
  </Section>
);

export default CompareCover;
